import { observer } from 'mobx-react-lite';
import { DeliveryOption } from '../../../../models/delivery-options/delivery-option';
import { useStore } from '../../../../stores/store';
import DeliveryProgress from './delivery-progress.component';
import { DeliveryOptionCardLeftContainer } from './styles';
import MileContentComponent from '../mile-content.component';
import { FlexContainer } from '../../../../common/flex-container/flex-container.styles';
import { useIsMobile } from '../../../../hooks/use-is-mobile.hook';
import {
  FirstMile,
  LastMile,
} from '../../../../models/delivery-options/delivery-miles';

interface Props {
  option: DeliveryOption;
  isOptionSelected: boolean;
  currencySymbol: string;
  onFirstMileSelected?: (
    option: DeliveryOption,
    lastMile: FirstMile,
    isOptionSelected: boolean
  ) => void;
  onLastMileSelected?: (
    option: DeliveryOption,
    lastMile: LastMile,
    isOptionSelected: boolean
  ) => void;
}

const DeliveryOptionCardLeft = ({
  option,
  isOptionSelected,
  currencySymbol,
  onFirstMileSelected,
  onLastMileSelected,
}: Props) => {
  const {
    parcelCreationStore: { countryDeparture, countryDestination },
  } = useStore();

  const isMobile = useIsMobile();

  const {
    first_miles: firstMiles,
    last_miles: lastMiles,
    selectedFirstMile,
    selectedLastMile,
  } = option;

  const hideDestinationMile = isMobile && !isOptionSelected;

  if (!selectedFirstMile || !selectedLastMile) return;

  return (
    <DeliveryOptionCardLeftContainer>
      <FlexContainer $align='start'>
        {!hideDestinationMile && <DeliveryProgress type='departure' />}
        <MileContentComponent
          type='first'
          mile={selectedFirstMile}
          allMiles={firstMiles}
          isCardSelected={isOptionSelected}
          onMileSelected={(mile) =>
            onFirstMileSelected?.(option, mile, isOptionSelected)
          }
          countryLocalizedName={countryDeparture?.localized_name}
          currencySymbol={currencySymbol}
        />
      </FlexContainer>
      {!hideDestinationMile && (
        <FlexContainer
          className='destination-mile-container'
          $align='start'>
          <DeliveryProgress type='destination' />
          <MileContentComponent
            type='last'
            mile={selectedLastMile}
            allMiles={lastMiles}
            isCardSelected={isOptionSelected}
            onMileSelected={(mile) =>
              onLastMileSelected?.(option, mile, isOptionSelected)
            }
            countryLocalizedName={countryDestination?.localized_name}
            currencySymbol={currencySymbol}
          />
        </FlexContainer>
      )}
    </DeliveryOptionCardLeftContainer>
  );
};

export default observer(DeliveryOptionCardLeft);
